import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { CreatorSection } from './components/CreatorSection';
import { BenefitsSection } from './components/BenefitsSection';
import { IncludesSection } from './components/IncludesSection';
import { IdealForSection } from './components/IdealForSection';
import { ResultsSection } from './components/ResultsSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { IncomeSection } from './components/IncomeSection';
import { ImageCarousel } from './components/ImageCarousel';
import { PricingSection } from './components/PricingSection';
import { CtaSection } from './components/CtaSection';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { FloatingCta } from './components/FloatingCta';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
import { CurrencyProvider } from './context/CurrencyContext';
export function App() {
  return <CurrencyProvider data-id="element-0">
      <div className="w-full bg-white text-gray-900 font-sans overflow-x-hidden" data-id="element-1">
        <MetaPixel data-id="element-2" />
        <Header data-id="element-3" />
        <main className="max-w-5xl mx-auto px-4 sm:px-6" data-id="element-4">
          <HeroSection data-id="element-5" />
          <ProblemSection data-id="element-6" />
          <SolutionSection data-id="element-7" />
          <CreatorSection data-id="element-8" />
          <BenefitsSection data-id="element-9" />
          <IncludesSection data-id="element-10" />
          <IdealForSection data-id="element-11" />
          <ResultsSection data-id="element-12" />
          <TestimonialsSection data-id="element-13" />
          <IncomeSection data-id="element-14" />
          <div className="py-8 bg-amber-50 rounded-lg mb-12 px-4" data-id="element-15">
            <h2 className="text-2xl md:text-3xl font-serif font-bold text-center text-amber-900 mb-8" data-id="element-16">
              Recetas Exclusivas de Bonificación
            </h2>
            <p className="text-lg text-amber-800 text-center font-medium mb-8" data-id="element-17">
              ¡Incluidas GRATIS con tu compra hoy!
            </p>
            <ImageCarousel data-id="element-18" />
          </div>
          <PricingSection data-id="element-19" />
          <CtaSection data-id="element-20" />
        </main>
        <Footer data-id="element-21" />
        <FloatingCta data-id="element-22" />
        <RecentPurchaseToast data-id="element-23" />
      </div>
    </CurrencyProvider>;
}